import React from "react";
import {useNavigate} from "react-router-dom";
import NiceButton from "../pictures/NiceButton";

const TransactionFailedPage = () => {
    const navigate = useNavigate();

    return (
        <div data-testid="transaction-failed-page" style={{textAlign: "center", padding: "40px", userSelect: 'text'}}>
            <h1>403</h1>
            <h2>Could not process your payment</h2>
            We are currently verifying whether the payment was processed. If there was an issue, we will notify you by
            email, or you can reach us at support@flextagram.com.
            <div style={{height: "12px"}}/>
            <NiceButton onClick={() => navigate("/")} text={'Go home'}/>
        </div>
    );
};

export default TransactionFailedPage;